import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=72265bd6&scoped=true&v-if=email"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"
import style0 from "./EditStaff.vue?vue&type=style&index=0&id=72265bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72265bd6",
  null
  
)

export default component.exports